import { ApiMessageType } from '../api_message_types'
import { MessageType } from '../message_types'
import Service from './service'
export var FingerprintScannerMessageType;
(function (FingerprintScannerMessageType) {
  FingerprintScannerMessageType["BARCODE_STATUS"] = "BARCODE_STATUS"
  FingerprintScannerMessageType["BARCODE_CONNECTED"] = "BARCODE_CONNECTED"
  FingerprintScannerMessageType["BARCODE_ERROR"] = "BARCODE_ERROR"
  FingerprintScannerMessageType["BARCODE_RESULT"] = "BARCODE_RESULT"
})(FingerprintScannerMessageType || (FingerprintScannerMessageType = {}))
export var ApiFingerprintScannerMessageType;
(function (ApiFingerprintScannerMessageType) {
  ApiFingerprintScannerMessageType["READER_BARCODE_REQUEST"] = "reader.barcode.request"
  ApiFingerprintScannerMessageType["READER_BARCODE_RESPONSE"] = "reader.barcode.response"
})(ApiFingerprintScannerMessageType || (ApiFingerprintScannerMessageType = {}))
export var FingerprintState;
(function (FingerprintState) {
  /** Ожидание сканирования */
  FingerprintState[FingerprintState["IDLE"] = 0] = "IDLE"
  /** Находится в процессе сканирования */
  FingerprintState[FingerprintState["PROCESS"] = 1] = "PROCESS"
  /** Ошибка сканера */
  FingerprintState[FingerprintState["HAVE_ERROR"] = 2] = "HAVE_ERROR"
  /** Сканер не подключен */
  FingerprintState[FingerprintState["NOT_CONNECTED"] = 3] = "NOT_CONNECTED"
})(FingerprintState || (FingerprintState = {}))
/**
* Сервис для работы со сканером отпечатков пальцев
* @version 0.0.1
* @since 1.9.0
*/
export default class FingerprintScannerService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiMessageType.FINGERPRINT_SCANNER_RESPONSE:
          if (message.user_id) {
            this.resolve(this.waiters.scan, message.user_id)
          }
          break
        case ApiMessageType.FINGERPRINT_SCANNER_ERROR:
          this.broadcast(MessageType.FINGERPRINT_SCANNER_ERROR, message.code, message.text)
          break
        case ApiMessageType.FINGERPRINT_SCANNER_STATE:
          this.broadcast(MessageType.FINGERPRINT_SCANNER_STATE, message.state)
          break
        case ApiMessageType.FINGERPRINT_SCANNER_STATUS:
          this.broadcast(MessageType.FINGERPRINT_SCANNER_STATUS, message.code, message.text)
          break
        case ApiMessageType.FINGERPRINT_SCANNER_FINISH:
          this.broadcast(MessageType.FINGERPRINT_SCANNER_FINISH, message.data_id, message.trust_value)
          break
      }
    }
    this.waiters = {
      scan: [],
    }
    this.messageChannel.subscribe(ApiMessageType.FINGERPRINT_SCANNER_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.FINGERPRINT_SCANNER_ERROR, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.FINGERPRINT_SCANNER_STATE, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.FINGERPRINT_SCANNER_STATUS, messageHandler)
    this.messageChannel.subscribe(ApiMessageType.FINGERPRINT_SCANNER_FINISH, messageHandler)
  }
  /**
     * Старт процесса сканирования
     *
     * @since 1.10.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Старт процесса сканирования</caption>
     * robot.fingerprintScannerService.onStart(() => {
     *   ...
     * })
     */
  onStart(callback) {
    return this.subscribe(MessageType.FINGERPRINT_SCANNER_START, callback)
  }
  /**
     * Сигнал об ошибке
     *
     * @since 1.10.0
     * @param {(code: number, text: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Сигнал об ошибке</caption>
     * robot.fingerprintScannerService.onError((code, text) => {
     *   ...
     * })
     */
  onError(callback) {
    return this.subscribe(MessageType.FINGERPRINT_SCANNER_ERROR, callback)
  }
  /**
     * Сигнал с новым состоянием сканера
     *
     * @since 1.10.0
     * @param {(state: FingerprintState) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Сигнал с новым состоянием сканера</caption>
     * robot.fingerprintScannerService.onState((state) => {
     *   ...
     * })
     */
  onState(callback) {
    return this.subscribe(MessageType.FINGERPRINT_SCANNER_STATE, callback)
  }
  /**
     * Сигнал со статусом сканирования
     *
     * @since 1.10.0
     * @param {(code: number, text: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Сигнал со статусом сканирования</caption>
     * robot.fingerprintScannerService.onStatus((code, text) => {
     *   ...
     * })
     */
  onStatus(callback) {
    return this.subscribe(MessageType.FINGERPRINT_SCANNER_STATUS, callback)
  }
  /**
     * Сигнал о завершении процесса сканирования
     *
     * @since 1.10.0
     * @param {(dataId: string, trustValue: number) => void} callback
     * dataId - uuid обладателя отпечатка (нулевой uuid, если отпечатка в базе нет)
     * trustValue - уверенность распознавания
     *
     * @return {*}  {UnsubscribeFunction}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Сигнал о завершении процесса сканирования</caption>
     * robot.fingerprintScannerService.onFinish((dataId, trustValue) => {
     *   ...
     * })
     */
  onFinish(callback) {
    return this.subscribe(MessageType.FINGERPRINT_SCANNER_FINISH, callback)
  }
  /**
     * Запустить процесс добавления отпечатка в базу
     *
     * @since 1.10.0
     * @param {boolean} [ignoreNotConnected=false] - игнорировать статус "Не подключен"
     * @return {*}  {Promise<string>}
     * @memberof FingerprintScannerService
     *
     * @example <caption>Запустить процесс добавления отпечатка в базу</caption>
     * robot.fingerprintScannerService.scanStart(true).then((uuid) => {
     *   console.log("Uuid is", uuid)
     * })
     */
  scanStart(ignoreNotConnected = false) {
    this.broadcast(MessageType.FINGERPRINT_SCANNER_START)
    return this.execute({
      type: ApiMessageType.FINGERPRINT_SCANNER_REQUEST,
      ignore_not_connected: ignoreNotConnected,
    }, this.waiters.scan)
  }
  /**
     * Отменить процесс добавления отпечатка
     *
     * @since 1.10.0
     * @memberof FingerprintScannerService
     *
     * @example <caption>Отменить процесс добавления отпечатка</caption>
     * robot.fingerprintScannerService.addUserStop()
     */
  addUserStop() {
    this.messageChannel.send({
      type: ApiMessageType.FINGERPRINT_SCANNER_REQUEST,
      cancel: 'foobar'
    })
  }
}
